const configs = {
	imageFolder: "/wp-content/themes/henri/_assets/images/",
	videoFolder: "/wp-content/themes/henri/_assets/video/",
	audioFolder: "/wp-content/themes/henri/_assets/audio/",
	mobileScreenSize: 760
};

export default configs;
